/** True when `widgetId` is a non-empty LiveChat / third-party id (excludes legacy `none`). */
export function isUsableChatWidgetId(widgetId: string | undefined | null): boolean {
  if (widgetId === undefined || widgetId === null) return false
  const t = widgetId.trim()
  return t.length > 0 && t !== 'none'
}
